import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDownloadBlueIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 30,
	height: 30,
	viewBox: "0 0 30 30",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M3.75 13.75V13.75C3.75 15.3937 3.75 16.2156 4.20398 16.7688C4.28709 16.8701 4.37995 16.9629 4.48121 17.046C5.03439 17.5 5.85626 17.5 7.5 17.5H8.55848C9.2542 17.5 9.60206 17.5 9.86395 17.6888C10.1258 17.8775 10.2358 18.2075 10.4558 18.8675L10.7942 19.8825C11.0142 20.5425 11.1242 20.8725 11.386 21.0612C11.6479 21.25 11.9958 21.25 12.6915 21.25H17.3085C18.0042 21.25 18.3521 21.25 18.614 21.0612C18.8758 20.8725 18.9858 20.5425 19.2058 19.8825L19.5442 18.8675C19.7642 18.2075 19.8742 17.8775 20.136 17.6888C20.3979 17.5 20.7458 17.5 21.4415 17.5H22.5C24.1437 17.5 24.9656 17.5 25.5188 17.046C25.6201 16.9629 25.7129 16.8701 25.796 16.7688C26.25 16.2156 26.25 15.3937 26.25 13.75V13.75",
			stroke: "#0061E8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10 11.25L15 15M15 15L20 11.25M15 15L15 2.5",
			stroke: "#0061E8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20 6.25H22.25C24.1356 6.25 25.0784 6.25 25.6642 6.83579C26.25 7.42157 26.25 8.36438 26.25 10.25V22.25C26.25 24.1356 26.25 25.0784 25.6642 25.6642C25.0784 26.25 24.1356 26.25 22.25 26.25H7.75C5.86438 26.25 4.92157 26.25 4.33579 25.6642C3.75 25.0784 3.75 24.1356 3.75 22.25V10.25C3.75 8.36438 3.75 7.42157 4.33579 6.83579C4.92157 6.25 5.86438 6.25 7.75 6.25H10",
			stroke: "#0061E8"
		})
	]
});
export default SvgDownloadBlueIcon;
